import { useTotalCallCount } from "@expert/sales-tools";
import { Text } from "@mantine/core";

import sharedStyles from "../cards/cardContent.module.css";
import { MetricCard } from "../cards/MetricCard";

/** Real-Time tab: pay-period call count from the gamification service — updates live during calls. */
export function TodayTotalCallsCard() {
    const { data, isLoading, isError } = useTotalCallCount();
    const callCount = data?.callCount ?? null;
    const isEmpty = !isLoading && (isError || callCount === null);

    return (
        <MetricCard
            title="Total calls"
            isLoading={isLoading}
            isEmpty={isEmpty}
            emptyValue="Unavailable"
            value={
                <Text component="span" className={sharedStyles.bigNumber}>
                    {callCount}
                </Text>
            }
            footer="No hard target"
            showTargetLabel={false}
        />
    );
}
